import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'
import { assert } from '../../../lib/assert-sidecar'
import { golfPhysicsTest } from '../physics/golfPhysicsTest-sidecar'
import { EGolfMessage } from './golfMessageIds'

export interface IGolfMessageSetFrame {
  frame: number
}

export const messageId = EGolfMessage.SetFrame

export function write(m: IMessageWriter, d: IGolfMessageSetFrame) {
  messageWriter.write8(m, messageId)
  messageWriter.write32(m, d.frame)
}
export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, messageId)

  let d: IGolfMessageSetFrame = {
    frame: messageWriter.read32(m),
  }

  return d
}

export function test() {
  let ex: IGolfMessageSetFrame = {
    frame: 235,
  }
  messageWriter.test('set-frame', ex, write, read)
}

export function process(m: IMessageWriter, isFromHost: boolean) {
  let msg = read(m)

  // TODO: also ping?
  if (!websockets.getIsHost()) {
    golfPhysicsTest.setFrame(msg.frame)
  }
}

export function sendMessageAndImmediatelyExecute(msg: IGolfMessageSetFrame) {
  websockets._sendMessageAndImmediatelyExecute(write, msg)
}
export function sendMessageWorldState(
  msg: IGolfMessageSetFrame,
  multiId: number,
) {
  websockets._sendMessageWorldState(write, msg, multiId)
}
